// import type { ComponentData } from '@ui/cms/contracts';
// TODO: Create proper separation of UI types
type ComponentData = any; // Temporary fix to avoid UI dependency
import { DeviceType } from './deviceType';
import { SchedulerConfig } from './schedulerConfig';

export const DragItemType = {
  Row: 'ROW',
  Component: 'COMPONENT',
} as const;
export type DragItemType = (typeof DragItemType)[keyof typeof DragItemType];

export const DropItemType = {
  Row: 'ROW',
  Column: 'COLUMN',
} as const;
export type DropItemType = (typeof DropItemType)[keyof typeof DropItemType];

export type DragItem = {
  id: string;
  type: DragItemType;
  index: number;
};

export type Layout = Pick<LayoutState, 'rootChildren' | 'rows' | 'columns' | 'components'>;

export interface LayoutState {
  rootChildren: string[];
  rows: Record<string, Row>;
  columns: Record<string, Column>;
  components: Record<string, Component>;
  focusedElement: string | null;
  componentSelector: {
    columnId: string;
  } | null;
  editComponentDialog: string | null;
  previewPage: boolean;
  layoutType: DeviceType;
}

export interface GradientStop {
  color: string;
  position: number; // 0-100 percentage
}

export type GradientType = 'linear' | 'radial';

export interface GradientConfig {
  type: GradientType;
  angle?: number; // For linear gradients (0-360 degrees)
  stops: GradientStop[];
}

export type BackgroundImageSource = 'url' | 'gallery' | 'upload';

export interface LayoutElementStyle {
  backgroundColor?: string;
  backgroundImage?: string;
  backgroundImageSource?: BackgroundImageSource;
  backgroundSize?: 'cover' | 'contain' | 'auto';
  backgroundPosition?: string;
  backgroundRepeat?: 'no-repeat' | 'repeat' | 'repeat-x' | 'repeat-y';
  gradient?: GradientConfig;
  height?: string; // CSS height value (e.g., '300px', '50vh')
  maxHeight?: string; // CSS max-height value (e.g., '500px', '80vh')
}

export interface Row {
  id: string;
  parentColumnId: string | null;
  columnIds: string[];
  style?: LayoutElementStyle;
}

export const ColumnAlignment = {
  Left: 'left',
  Center: 'center',
  Right: 'right',
} as const;
export type ColumnAlignment = (typeof ColumnAlignment)[keyof typeof ColumnAlignment];

export const ColumnDirection = {
  Bottom: 'bottom',
  Right: 'right',
} as const;
export type ColumnDirection = (typeof ColumnDirection)[keyof typeof ColumnDirection];

export interface Column {
  id: string;
  parentRowId: string;
  size: number;
  childrenIds: string[];
  alignment?: ColumnAlignment;
  direction?: ColumnDirection;
  style?: LayoutElementStyle;
  fitToSiblings?: boolean; // When true, column matches sibling height instead of expanding the row
}

export type Component = ComponentData & {
  parentColumnId: string;
  /** Whether the component is enabled (defaults to true if not set) */
  isEnabled?: boolean;
  /** Scheduler configuration for conditional display */
  scheduler?: SchedulerConfig;
};

export type CmsPage = {
  id: string;
  name: string;
  slug: string;
  /** Whether this page version is currently active */
  isActive?: boolean;
  /** Priority for determining which version to show (higher = more priority) */
  priority?: number;
  /** Scheduler configuration for conditional activation */
  scheduler?: SchedulerConfig;
  desktopLayout?: Layout;
  tabletLayout?: Layout;
  mobileLayout?: Layout;
  meta?: {
    title?: string;
    description?: string;
    image?: string;
  };
};
